<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Activity Detailled Planning
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 sm8 md6 lg6>
              <DatePicker :date= "{
                obj: 'stats.dcrt',
                label: dateTypeA(this.getDetailStats.dcrt),
                hint: 'created',
                icon: 'edit_calendar'
                }"
              />
            </v-flex>
            <v-flex xs12 sm8 md6 lg6>
              <DatePicker :date= "{
                obj: 'stats.drev',
                label: dateTypeA(this.getDetailStats.drev),
                hint: 'review',
                icon: 'event_note'
                }"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 sm8 md6 lg6>
              <DatePicker :date= "{
                obj: 'stats.dstr',
                label: dateTypeA(this.getDetailStats.dstr),
                hint: 'plan start',
                icon: 'edit_calendar'
                }"
              />
            </v-flex>
            <v-flex xs12 sm8 md6 lg6>
              <DatePicker :date= "{
                obj: 'stats.dend',
                label: dateTypeA(this.getDetailStats.dend),
                hint: 'plan end',
                icon: 'event_note'
                }"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 sm6 md3>
              <v-text-field
                :change="updateFormChar()"
                v-model="localForm.shift"
                :rules="ruleNumberMoreThanZero"
                color="wplblue0"
                prepend-icon="timer"
                hint="shift duration"
                persistent-hint
                ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                :change="updateFormChar()"
                v-model="localForm.perday"
                :rules="ruleNumberMoreThanZero"
                color="wplblue0"
                prepend-icon="hourglass_bottom"
                hint="shifts / day"
                persistent-hint
                ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                :change="updateFormChar()"
                v-model="localForm.free"
                :rules="ruleNumberMoreThanZero"
                color="wplblue0"
                prepend-icon="free_breakfast"
                hint="free days"
                persistent-hint
                ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                :change="updateFormChar()"
                v-model="localForm.derate"
                :rules="ruleNumberMoreThanZero"
                color="wplblue0"
                prepend-icon="build"
                hint="derating factor"
                persistent-hint
                ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row class="mr-2 mt-2">
            <v-spacer/>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor"> date_range </v-icon>
                <div :class="ui.textSubheadingBold">
                {{this.calcNumOfDays(this.getDetailStats, "str-end") - localForm.free}} days
              </div>
            </v-chip>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor"> schedule </v-icon>
                <div :class="ui.textSubheadingBold">
                  {{this.calcAvailHours(this.getDetailChar, this.getDetailStats)}} hrs
              </div>
            </v-chip>
          </v-layout>
        </div>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import DatePicker from "@/data/functions/components/DatePicker";
import timeFunctions from "@/data/functions/mixins/timeFunctions.js";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        plbud: "",
        dep: "",
        perday: "",
        shift: "",
        derate: "",
        free: ""
      },
      orgForm: {
        plbud: "",
        dep: "",
        perday: "",
        shift: "",
        derate: "",
        free: ""
      }
    };
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.plbud = this.getDetail.char.plbud;
    this.localForm.dep = this.getDetail.char.dep;
    this.localForm.perday = this.getDetail.char.perday;
    this.localForm.shift = this.getDetail.char.shift;
    this.localForm.derate = this.getDetail.char.derate;
    this.localForm.free = this.getDetail.char.free;

    this.orgForm.plbud = this.getDetail.char.plbud;
    this.orgForm.dep = this.getDetail.char.dep;
    this.orgForm.perday = this.getDetail.char.perday;
    this.orgForm.shift = this.getDetail.char.shift;
    this.orgForm.derate = this.getDetail.char.derate;
    this.orgForm.free = this.getDetail.char.free;
  },
  // eslint-disable-next-line
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    dateFunctions,
    timeFunctions
  ],
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailChar",
      "getDetailStats",
      "getCurrentPage"
    ])
  },
  components: {
    DatePicker
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.plbud !== this.orgForm.plbud &&
        this.localForm.plbud !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.plbud = this.localForm.plbud;
        // basic
        char.plbud = this.localForm.plbud;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.dep !== this.orgForm.dep &&
        this.localForm.dep !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.dep = this.localForm.dep;
        // basic
        char.dep = this.localForm.dep;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.shift !== this.orgForm.shift &&
        this.localForm.shift !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.shift = this.localForm.shift;
        // basic
        char.shift = this.localForm.shift;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.perday !== this.orgForm.perday &&
        this.localForm.perday !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.perday = this.localForm.perday;
        // basic
        char.perday = this.localForm.perday;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.free !== this.orgForm.free &&
        this.localForm.free !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.free = this.localForm.free;
        // basic
        char.free = this.localForm.free;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.derate !== this.orgForm.derate &&
        this.localForm.derate !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.derate = this.localForm.derate;
        // basic
        char.derate = this.localForm.derate;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
